import ForumContent from './ForumContent'
import { useEffect, useState } from 'react'
import axios from '../config/axios'
import classes from './forumContentPopup.module.css'

const ForumContentPopup = ({ apiPostPath, id }) => {
  const [data, setData] = useState()

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`/${apiPostPath}/${id}`)

        if (response.data && response.data.post) {
          setData(response.data.post)
        } else {
          setData({})
        }
      } catch (err) {
        console.error('Error fetching post:', err)
        setData({})
      }
    }

    fetchData()
  }, [apiPostPath, id])

  return (
    <div className={classes.wrapper}>
      {data && <ForumContent description={data.textField} items={data.items} />}
    </div>
  )
}

export default ForumContentPopup
